import React, { Component } from 'react'
import { connect } from 'react-redux'
import { lifecycle, compose, mapProps, nest, withState, withHandlers } from 'recompose'
import T from 'i18n-react'
import injectSagas from 'helpers/injectSagas'

import styles from './styles.scss'

import Card from './Card'
import CardHeader from 'components/custom/Card/CardHeader'
import Section from 'components/custom/Section/Section'
import Divider from 'components/fulcrum/divider/Divider'
import Actions from './Actions'

import {
  default as Collapse,
  withCollapse
} from 'components/fulcrum/collapse/Collapse'

import AEDetailsSpec from './AEDetailsSpec'
import LastUpdated from 'components/display/LastUpdated'

import { fetchAEDetails, fetchAEDetailsSelection, postAEDetails } from './actions';
import { MODULE_NAME } from './constants'
import sagas from './sagas'
import { 
  aeDetailsSelector, 
  aeDetailsParamsSelector, 
  aeDetailsLastUpdatedDateSelector, 
  aeDetailsLastUpdatedNameSelector 
} from './selectors';
import { projectIdSelector } from 'containers/Project/View/selectors'

import hideOnAnyRoles from 'containers/Role/Hide/AllGlobalRoles'
import { GLOBAL_ROLES } from 'containers/Role/constants'

const mapStateToProps = state => {
  return {
    projectId: projectIdSelector(state),
    aeDetails: aeDetailsSelector(state),
    aeDetailsParams: aeDetailsParamsSelector(state),
    lastUpdatedName: aeDetailsLastUpdatedNameSelector(state),
    lastUpdateDate: aeDetailsLastUpdatedDateSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchAEDetails: (projectId) => dispatch(fetchAEDetails(projectId)),
    fetchAEDetailsSelection: () => dispatch(fetchAEDetailsSelection()),
    postAEDetails: (projectId, params) => dispatch(postAEDetails(projectId, params))
  }
}

class ProjectExecutionCard extends Component {

  render() {
    const {
      aeDetails,
      aeDetailsParams,
      projectId,
      collapse,
      toggleCollapse,
      edit,
      toggleEdit,
      fetchAEDetailsSelection,
      postAEDetails,
      lastUpdateDate,
      lastUpdatedName
    } = this.props

    return (
      <Card>
        <CardHeader title={T.translate('containers.project.projectExecutionSection.index.header')}>
          <Actions
            collapse={collapse}
            toggleCollapse={toggleCollapse}
            edit={edit}
            onEdit={fetchAEDetailsSelection}
            toggleEdit={toggleEdit}
            onSave={() => postAEDetails(projectId, aeDetailsParams)}
          />
        </CardHeader>
        <LastUpdated name={lastUpdatedName} date={lastUpdateDate} />
        <Divider className={styles.divider}/>
        <Collapse collapse={collapse}>
          <AEDetailsSpec edit={edit} aeDetails={aeDetails} />
        </Collapse>
      </Card>
    )
  }
}

const ProjectExecutionSection = nest(Section, ProjectExecutionCard)

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: sagas})
const withModify = compose(
  withState('edit', 'changeEdit', false),
  withHandlers({
    toggleEdit: ({changeEdit}) => () => changeEdit(e => !e)
  })
)
const withRoles = compose(
  mapProps(
    (props) => ({
      ...props,
      roles: [
        GLOBAL_ROLES.CLIENT_ACCESS,
      ]
    })
  ),
  hideOnAnyRoles,
)

const enhance = compose(
  withRoles,
  withSagas,
  withConnect,
  withCollapse,
  withModify,
  lifecycle({
    componentWillMount() { 
      const {fetchAEDetails, id} = this.props
      fetchAEDetails(id)
    },
    componentWillUnmount() { }
  })
)

export default enhance(ProjectExecutionSection)
